module.exports = __webpack_public_path__ + "static/media/speed.a4bbc9de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skywire/images/speed.svg
// module id = 1135
// module chunks = 0